module.exports = __webpack_public_path__ + "img/PXL_20230526_091553075.43f9e576.jpg";